export enum ThemeButtonEnum {
  PRIMARY = "primary",
  PILL = "pill",
  SECONDARY = "secondary",
  SECONDARY_ALT = "secondaryAlt",
  SECONDARY_DARKGREY = "secondaryDarkGrey",
  TEXT = "text",
  LINK = "link",
}
export enum ColorButtonEnum {
  RED = "red",
  WARMGREY = "warmGrey",
  LIGHTGREY = "lightGrey",
  DARKGREY = "darkGrey",
  BLACK = "black",
  WHITE = "white",
}
export enum TypeButtonEnum {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset",
}
export enum SizeButtonEnum {
  XL = "xl",
  LARGE = "lg",
  MEDIUM = "md",
  SMALL = "sm",
  XS = "xs",
  XXS = "xxs",
  LARGE_ICON = "largeIcon",
  MEDIUM_ICON = "mediumIcon",
  SMALL_ICON = "smallIcon",
}

export enum VariantButtonEnum {
  TEXT = "text",
  LINK = "link",
}
export type ThemeButtonType = `${ThemeButtonEnum}`;
export type SizeButtonType = `${SizeButtonEnum}`;
export type TypeButtonType = `${TypeButtonEnum}`;
export type ColorButtonType = `${ColorButtonEnum}`;
export type VariantButtonType = `${VariantButtonEnum}`;
export type GroupType = boolean | "first" | "last" | "middle";
